export default __webpack_public_path__ + "static/media/harmony-o-s.e882755b.svg";